import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import CartSidebar from './components/CartSidebar';
import Footer from './components/Footer';
import Home from './pages/Home';
import './App.css';

const Chairs = lazy(() => import('./pages/Chairs'));
const Tables = lazy(() => import('./pages/Tables'));
const Tents = lazy(() => import('./pages/Tents'));
const Kiddies = lazy(() => import('./pages/Kiddies'));
const Accessories = lazy(() => import('./pages/Accessories'));
const Packages = lazy(() => import('./pages/Packages'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Confirmation = lazy(() => import('./pages/Confirmation'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Blog = lazy(() => import('./pages/Blog'));
const Admin = lazy(() => import('./pages/Admin'));
const RequestQuote = lazy(() => import('./pages/RequestQuote'));
const RentalPolicies = lazy(() => import('./pages/RentalPolicies'));
const PhiladelphiaRentals = lazy(() => import('./pages/landing/PhiladelphiaRentals'));
const DelawareCountyRentals = lazy(() => import('./pages/landing/DelawareCountyRentals'));
const MainLineRentals = lazy(() => import('./pages/landing/MainLineRentals'));
const TentRentalsPhilly = lazy(() => import('./pages/landing/TentRentalsPhilly'));
const TableChairRentalsPhilly = lazy(() => import('./pages/landing/TableChairRentalsPhilly'));
const GraduationRentalsPhilly = lazy(() => import('./pages/landing/GraduationRentalsPhilly'));
const TentSizeGuide = lazy(() => import('./pages/articles/TentSizeGuide'));
const SeatingLayoutGuide = lazy(() => import('./pages/articles/SeatingLayoutGuide'));
const DeliveryChecklist = lazy(() => import('./pages/articles/DeliveryChecklist'));
const ChiavariVsFolding = lazy(() => import('./pages/articles/ChiavariVsFolding'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FFF7ED' }}>
    <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-orange-500 border-t-transparent"></div>
  </div>
);

function App() {
  return (
    <CartProvider>
        <BrowserRouter>
          <div className="App">
            <Navbar />
            <CartSidebar />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/chairs" element={<Chairs />} />
                <Route path="/tables" element={<Tables />} />
                <Route path="/tents" element={<Tents />} />
                <Route path="/kiddies" element={<Kiddies />} />
                <Route path="/accessories" element={<Accessories />} />
                <Route path="/balloons" element={<Navigate to="/accessories" replace />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/confirmation" element={<Confirmation />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/request-a-quote" element={<RequestQuote />} />
                <Route path="/rental-policies" element={<RentalPolicies />} />
                <Route path="/party-rentals-philadelphia-pa" element={<PhiladelphiaRentals />} />
                <Route path="/party-rentals-delaware-county-pa" element={<DelawareCountyRentals />} />
                <Route path="/party-rentals-main-line-pa" element={<MainLineRentals />} />
                <Route path="/tent-rentals-philadelphia-pa" element={<TentRentalsPhilly />} />
                <Route path="/table-chair-rentals-philadelphia-pa" element={<TableChairRentalsPhilly />} />
                <Route path="/graduation-party-rentals-philadelphia-pa" element={<GraduationRentalsPhilly />} />
                <Route path="/blog/what-size-tent-do-i-need" element={<TentSizeGuide />} />
                <Route path="/blog/how-many-tables-and-chairs-do-i-need" element={<SeatingLayoutGuide />} />
                <Route path="/blog/party-rental-delivery-checklist" element={<DeliveryChecklist />} />
                <Route path="/blog/chiavari-vs-folding-chairs" element={<ChiavariVsFolding />} />
              </Routes>
            </Suspense>
            <Footer />
          </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;